<template>
  <div class="not-supported">
    <div class="not-supported-overlay"></div>
    <p class="not-supported__heading">{{ $t('Not Supported title') }}</p>
    <p class="not-supported__subheading">
      {{ $t('Not Supported description') }}
    </p>
    <ul class="list--vertical">
      <li>
        <a href="https://www.google.pl/intl/pl/chrome/">
          <img class="not-supported__icon" src="@/assets/google_chrome.svg" alt="Google Chrome" />
        </a>
      </li>
      <li>
        <a href="https://www.mozilla.org/pl/firefox/new/#">
          <img
            class="not-supported__icon"
            src="@/assets/mozilla_firefox.svg"
            alt="Mozilla Firefox"
          />
        </a>
      </li>
      <li>
        <a href="https://www.opera.com/">
          <img class="not-supported__icon" src="@/assets/opera.svg" alt="Opera" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style lang="scss" scoped>
@import '~@/styles/NotSupported.scss';
</style>
